import './Menu.css';
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleLeft, faCircleRight, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { EditText } from 'react-edit-text';

function Menu() {
  let navigate = useNavigate();

  // Declaring all variables as states
  const [worlds, setWorlds] = useState([]);
  const [worldIndex, setWorldIndex] = useState(0);

  const [newWorld, setNewWorld] = useState("");
  const [joinWorldID, setJoinWorldID] = useState("");
  const [worldImage, setWorldImage] = useState("/images/menu_sample.jpg");

  // Async function for fetching worlds
  const fetchWorlds = async (worldName = null) => {
    const response = await fetch('api/worlds', {
      method: 'GET',
      headers: {
        "x-api-key": localStorage.getItem("api_key")
      }
    });

    const json = await response.text();
    const obj = JSON.parse(json);

    if (response.status == 200) {
      setWorlds(obj);
      if (worldName !== null) {
        setWorldIndex(obj.findIndex(world => world.name === worldName));
      }
    } else {
      alert(obj.message);
    }
  }

  // useEffect to fetchWorlds() when the page loads
  useEffect(() => {
    fetchWorlds();
  }, []);

  // Return the user to the login page and remove their authentication (delete API key)
  function logOut(e) {
    e.preventDefault();

    localStorage.clear("api_key");
    navigate("/");
  }

  // Display different world based on the direction the user clicked
  // Left is -1 and right is 1
  function changeWorlds(direction) {
    if (worldIndex + direction >= worlds.length) {
      setWorldIndex(0);
      return;
    }

    if (worldIndex + direction < 0) {
      setWorldIndex(worlds.length - 1);
      return;
    }

    setWorldIndex(worldIndex + direction);
  }

  // Request method to create a new world
  // Using the state variable to send the world name as JSON
  const createNewWorld = async () => {
    if (newWorld === "") {
      alert("Please enter a world name");
      return;
    }

    const response = await fetch('api/worlds', {
      method: 'POST',
      headers: {
        "x-api-key": localStorage.getItem("api_key")
      },
      body: JSON.stringify({
        "name": newWorld,
        "image_url": `default${Math.floor(Math.random() * 10) + 1}.png`
      })
    });

    const json = await response.text();
    const obj = JSON.parse(json);

    if (response.status != 201) {
      alert(obj.errors[0]);
      console.log(obj);
      return;
    } else {
      alert(`World with name ${newWorld} created!`);
    }
    
    fetchWorlds(newWorld);
    setNewWorld("");
  }

  // Request to join a world of a different user
  // Using the state variable to send the world ID as JSON 
  const joinWorld = async () => {
    if (joinWorldID === "") {
      alert("Please enter a join world ID");
      return;
    }

    const response = await fetch('api/worlds/join', {
      method: 'POST',
      headers: {
        "x-api-key": localStorage.getItem("api_key")
      },
      body: JSON.stringify({
        "share_id": joinWorldID
      })
    });

    const json = await response.text();
    const obj = JSON.parse(json);

    if (response.status != 200) {
      alert(obj.errors[0]);
      console.log(obj);
      return;
    } else {
      alert (`Joined world with ID ${joinWorldID}!`);
      setJoinWorldID("");
    }

    fetchWorlds();
  }

  // Request to delete the world
  const deleteWorld = async () => {
    // Only after the user has confirmed is the world deleted
    if (window.confirm("Are you sure you want to delete this world?")) {
      const response = await fetch(`api/worlds/${worlds[worldIndex].id}`, {
        method: 'DELETE',
        headers: {
          "x-api-key": localStorage.getItem("api_key")
        }
      });

      const json = await response.text();
      const obj = JSON.parse(json);

      if (response.status !== 200) {
        alert("An error occured, check your console");
        console.log(obj);
      } else {
        setWorldIndex(0);
      }

      fetchWorlds();
    }
  }

  // Request to update the world name
  const updateWorldName = async (name) => {
    if (name === "") {
      alert("Please enter a name for the world");
      return;
    }

    const response = await fetch(`api/worlds/${worlds[worldIndex].id}`, {
      method: 'PATCH',
      headers: {
        "x-api-key": localStorage.getItem("api_key")
      },
      body: JSON.stringify({
        "name": name, // Name is passed down as a parameter from input
      })
    });

    const json = await response.text();
    const obj = JSON.parse(json);

    if (response.status != 200) {
      alert("An error occured, check your console");
      console.log(obj);
      return;
    }

    fetchWorlds();
  }

    // Request to update the world name
    const updateWorldImage = async (image) => {
      if (!image) {
        alert("An error occured, the image wasn't upload please try again");
        return;
      }
  
      const response = await fetch(`api/worlds/${worlds[worldIndex].id}`, {
        method: 'PATCH',
        headers: {
          "x-api-key": localStorage.getItem("api_key")
        },
        body: JSON.stringify({
          "image_base64": image
        })
      });
  
      const json = await response.text();
      const obj = JSON.parse(json);
  
      if (response.status != 200) {
        alert("An error occured, check your console");
        console.log(obj);
        return;
      }
  
      fetchWorlds();
    }
  
  // Function to set the state of the world image URL
  // The URL is then applied to the menu selection image
  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
      if ((encoded.length % 4) > 0) {
        encoded += '='.repeat(4 - (encoded.length % 4));
      }
      resolve(encoded);
    };
    reader.onerror = error => reject(error);
  });

  async function loadFile(e) {
    const file = e.target.files[0];
    updateWorldImage(await toBase64(file));
  }

  return (
    <div>
      <header className="navbar">
        <button className="btn" onClick={(e) => logOut(e)}>Log out</button>
        <h1>Minecraft Coordinate Storage System</h1>
        <p>Successfully logged in</p>
      </header>
      <section className="menu-content">
        {worlds && worlds.length > 0 &&
          <div className="select-world">
            <h1>Select World</h1>
            <div className="holder">
              <div className="delete-icon" onClick={() => deleteWorld()}>
                <FontAwesomeIcon icon={faTrashCan} size="2x" className="icon" />
              </div>
              <Link to="/map" state={{ world: worlds[worldIndex] }}>
                <img className="img-holder" src={`/world_images/${worlds[worldIndex].image_url}`} alt="menu_sample" />
              </Link>
              <div className="selector">
                {worlds.length > 1 &&
                  <div onClick={() => changeWorlds(-1)}>
                    <FontAwesomeIcon icon={faCircleLeft} size="2x" className="icon" />
                  </div>
                }
                <EditText
                  className="world-name"
                  defaultValue={worlds[worldIndex].name}
                  onSave={({ value }) => updateWorldName(value)}
                  style={{
                    fontSize: "25px",
                    width: "inherit",
                  }}
                  inline />
                {worlds.length > 1 &&
                  <div onClick={() => changeWorlds(1)}>
                    <FontAwesomeIcon icon={faCircleRight} size="2x" className="icon" />
                  </div>
                }
              </div>
            </div>
            <input type="file" className="btn" accept='image/*' onChange={(e) => loadFile(e)} />
          </div>
        }
        <div className="change-world">
          <div className="create-world">
            <h1>Create New World</h1>
            <div className="holder">
              <div className="form-group">
                <label>World Name: </label><br />
                <input type="text" onChange={(e) => setNewWorld(e.target.value)} value={newWorld} placeholder='Enter World Name'></input>
              </div>
              <div className="form-group">
                <button type="submit" className="btn" onClick={createNewWorld}>Create New World</button>
              </div>
            </div>
          </div>
          <div className="add-world">
            <h1>Join Shared World</h1>
            <div className="holder">
              <div className="form-group">
                <label>World ID: </label><br />
                <input type="number" onChange={(e) => setJoinWorldID(e.target.value)} value={joinWorldID} placeholder='Enter World ID'></input>
              </div>
              <div className="form-group">
                <button type="submit" className="btn" onClick={() => joinWorld()}>Join World</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Menu;
